import _get from 'lodash/get';

export default class ProductFilterForm {
  /* @ngInject */
  constructor(ProductFilterService, ProductService, RouterService, PRODUCT_CONSTANT) {
    this.routerService = RouterService;
    this.productService = ProductService;
    this.productFilterService = ProductFilterService;
    this.PRODUCT_CONSTANT = PRODUCT_CONSTANT;
  }

  $onInit() {
    if (!this.productFilterService.SELECT || !this.productFilterService.DEFAULT_OPTIONS) {
      this.productFilterService.initFilters();
    }
    this.filtersAreVisible = true;
    // this.isPersonalShopper = this.authService.isPersonalShopper();
    this.selectPlaceholders = this.formatPlaceholders();
    this.selectPlaceholdersDefaultOptions = this.productFilterService.DEFAULT_OPTIONS;
    this.getBaseFilters().then((getBaseFilterData) => {
      this.baseFilters = this.createBaseFilterByGenderKey(this.routerService.location.search().genderId, getBaseFilterData);
      this.activeFilters = this.setActiveFilters(this.baseFilters);
      this.applySearch({initParams: this.routerService.location.search()});
    });
  }

  getBaseFilters() {
    return this.productFilterService.getBaseFilters();
  }

  getFilters(params, options = {}) {
    this.loadingFilters = true;
    return this.productFilterService.query(params, options);
  }

  onFilterSuccess(newFilters, filterNameChanged) {
    this.loadingFilters = false;
    this.filters = this.setFilters(this.filters, newFilters, filterNameChanged);
    this.activeFilters = this.setActiveFilters([...this.baseFilters, ...this.filters]);
    if (this.onFilterReady) {
      this.onFilterReady()(Object.assign({}, this.activeFilters));
    }
  }

  setFilters(oldFilters = [], newFilters, filterNameChanged) {
    const prevFilter = oldFilters.find(f => f.name === filterNameChanged);
    const prevFilterIndex = oldFilters.findIndex(f => f.name === filterNameChanged);
    const newFilterIsNull = filterNameChanged && this.activeFilters[filterNameChanged].value === null;
    const canRewriteOldOptions = prevFilter && prevFilterIndex >= 0;
    const hasClearedFilter = oldFilters.length === 4;
    if (canRewriteOldOptions && !hasClearedFilter && !newFilterIsNull) {
      return Object.assign(newFilters, {[prevFilterIndex]: prevFilter});
    }
    this.orderAvailabilityOptions(newFilters);
    return newFilters;
  }

  setActiveFilters(newFilters = [], forcedParams) {
    const {AVAILABILITY} = this.PRODUCT_CONSTANT.FILTER;
    const params = forcedParams || this.routerService.location.search();
    const activeFilters = {};
    newFilters.forEach((filter) => {
      const preselectedValueFromParams = params[`${filter.name}Id`] || params[filter.name];
      const preselectedOption = filter.options.find(o => o.value === preselectedValueFromParams);
      if (preselectedValueFromParams && preselectedOption) {
        activeFilters[filter.name] = preselectedOption;
      } else if (!preselectedValueFromParams && filter.name === AVAILABILITY) {
        const defaultAvailability = this._getDefaultAvailabilityValue();
        activeFilters[filter.name] = filter.options.find(o => o.value === defaultAvailability);
      } else {
        activeFilters[filter.name] = filter.options[0];
      }
    });
    activeFilters.q = {value: params.q};
    activeFilters.hasImages = {value: params.hasImages === '1'};
    activeFilters.excludeFromClothingAllowance = {value: params.excludeFromClothingAllowance === '0'};
    return activeFilters;
  }

  _getDefaultAvailabilityValue() {
    const {IN_STOCK} = this.PRODUCT_CONSTANT.FILTER;
    return IN_STOCK;
    // return this.isPersonalShopper ? IN_MARKET : BOUGHT_BY_MARKET;
  }

  createParamsFromActiveFilters(activeFilters) {
    const {SIZE, AVAILABILITY, HAS_IMAGES, EXCLUDE_FROM_CLOTHING_ALLOWANCE} = this.PRODUCT_CONSTANT.FILTER;
    return Object.keys(activeFilters).reduce((_params, _filter) => {
      const value = activeFilters[_filter] ? activeFilters[_filter].value : null;
      if (_filter === 'q') {
        _params[_filter] = value || null;
      } else if (_filter === AVAILABILITY || _filter === SIZE) {
        _params[_filter] = value;
      } else if (_filter === HAS_IMAGES) {
        _params[_filter] = this._getHasImagesValueFormatted(value);
      } else if (_filter === EXCLUDE_FROM_CLOTHING_ALLOWANCE) {
        _params[_filter] = this._getExcludeFromClothingAllowanceValueFormatted(value);
      } else {
        _params[`${_filter}Id`] = value;
      }
      return _params;
    }, {});
  }

  toggleFilters() {
    this.filtersAreVisible = !this.filtersAreVisible;
  }

  applyBaseFilters({activeFilters, filterNameChanged}) {
    const {GENDER, AVAILABILITY, CATEGORY, REGION, MARKET, STORE} = this.PRODUCT_CONSTANT.FILTER;
    this.getBaseFilters().then((getBaseFilterData) => {
      const isChangedGender = filterNameChanged === GENDER;
      const isChangedGeography = filterNameChanged === REGION || filterNameChanged === MARKET || filterNameChanged === STORE;
      const newParams = this.createParamsFromActiveFilters(activeFilters);
      const geoFilters = this.filterGeographyFilters();
      const enrichedBaseFilters = [...this.baseFilters, ...geoFilters];
      const forceValues = {
        ...newParams,
        [`${CATEGORY}Id`]: isChangedGender ? this.productFilterService.DEFAULT_OPTIONS[CATEGORY].value : newParams[`${CATEGORY}Id`],
        [AVAILABILITY]: this.activeFilters[AVAILABILITY].value,
      };
      this.baseFilters = this.createBaseFilterByGenderKey(activeFilters.gender.value, getBaseFilterData);
      this.activeFilters = this.setActiveFilters(enrichedBaseFilters, forceValues);
      this.routerService.location.search(newParams);
      if (isChangedGender) {
        delete newParams.categoryId;
      } else if (isChangedGeography) {
        const params = this.productFilterService.defaultParams(this.createParamsFromActiveFilters(activeFilters));
        this.getFilters(this._formatParamsWithGeoFilters(params, filterNameChanged))
          .then(newFilters => this.onFilterSuccess(newFilters, filterNameChanged));
      } else {
        this.applySearch({activeFilters: this.activeFilters});
      }
    });
  }

  applySearch({initParams, activeFilters, filterNameChanged}) {
    const shouldReloadPage = this.reloadPageOnChange !== false;
    const params = this.productFilterService.defaultParams(initParams || this.createParamsFromActiveFilters(activeFilters));
    const paramsWithGeography = this._formatParamsWithGeoFilters(params, filterNameChanged);

    if (initParams || !shouldReloadPage) {
      this.getFilters(paramsWithGeography, {cacheable: false}).then(newFilters => this.onFilterSuccess(newFilters, filterNameChanged));
    }
    // se non sto inizializzando il primo valore in queryString
    // setto la nuova url senza aggiungerla alla storia del browser
    if (!initParams) {
      // const urlParams = this._formatUrlParams(paramsWithGeography);
      this.routerService.location.search(paramsWithGeography).replace();
      if (shouldReloadPage) {
        this.productService.resetStore();
        this.routerService.state.go('products', paramsWithGeography, {reload: true});
      }
    }
    if (this.onFilterSubmit && !initParams) {
      this.onFilterSubmit()({...paramsWithGeography}, {isTriggeredSubmitButton: !filterNameChanged && !initParams});
    }
  }

  applyGeographySearch({activeFilters, filterNameChanged}) {
    const {AVAILABILITY} = this.PRODUCT_CONSTANT.FILTER;
    if (filterNameChanged === AVAILABILITY && !this._hasGenderAndCategory()) {
      this._addParamsToQueryString({[AVAILABILITY]: this.activeFilters.availability.value});
      return;
    }

    if (!activeFilters.category.value) {
      this.applyBaseFilters({activeFilters, filterNameChanged});
    } else {
      this.applySearch({activeFilters, filterNameChanged});
    }
  }

  _getHasImagesValueFormatted(value) {
    return value ? '1' : null;
  }

  applyOnlyWithImagesSearch({activeFilters}) {
    const {HAS_IMAGES} = this.PRODUCT_CONSTANT.FILTER;
    if (!this._hasGenderAndCategory()) {
      const value = this._getHasImagesValueFormatted(this.activeFilters.hasImages.value);
      this._addParamsToQueryString({[HAS_IMAGES]: value});
      return;
    }

    this.applySearch({activeFilters});
  }

  _getExcludeFromClothingAllowanceValueFormatted(value) {
    return value ? '0' : null;
  }

  applyExcludeFromClothingAllowanceSearch({activeFilters}) {
    const {EXCLUDE_FROM_CLOTHING_ALLOWANCE} = this.PRODUCT_CONSTANT.FILTER;
    if (!this._hasGenderAndCategory()) {
      const value = this._getExcludeFromClothingAllowanceValueFormatted(this.activeFilters.excludeFromClothingAllowance.value);
      this._addParamsToQueryString({[EXCLUDE_FROM_CLOTHING_ALLOWANCE]: value});
      return;
    }

    this.applySearch({activeFilters});
  }


  _hasGenderAndCategory() {
    const categoryValue = this.activeFilters.category.value;
    const genderValue = this.activeFilters.gender.value;
    return categoryValue && genderValue;
  }

  _addParamsToQueryString(newParams) {
    const params = this.routerService.location.search();
    this.routerService.location.search({...params, ...newParams});
  }

  _formatParamsWithGeoFilters(params, filterNameChanged) {
    const {REGION, MARKET} = this.PRODUCT_CONSTANT.FILTER;
    if (filterNameChanged === REGION) {
      return {...params, marketId: null, storeId: null };
    }
    if (filterNameChanged === MARKET) {
      return {...params, storeId: null };
    }

    return params;
  }

  // _formatUrlParams(params) {
  //   const {AVAILABILITY, IN_MARKET, NEW, COMING_SOON} = this.PRODUCT_CONSTANT.FILTER;
  //   if (params.launchDate && params[AVAILABILITY] === IN_MARKET) {
  //     const isNewLaunchDate = params.launchDate === this.productFilterService.getLaunchDatesFilters('new');
  //     const placeholderAvailabilityUrl = isNewLaunchDate ? NEW : COMING_SOON;
  //     console.log(placeholderAvailabilityUrl);
  //     return {
  //       ...params,
  //       [AVAILABILITY]: placeholderAvailabilityUrl,
  //     };
  //   }
  //   return params;
  // }

  createBaseFilterByGenderKey(genderKey, {SELECT_GENDER, sections}) {
    const newSection = sections.find(section => section.gender[0].value === genderKey) || {};
    const {CATEGORY} = this.PRODUCT_CONSTANT.FILTER;
    return [
      SELECT_GENDER,
      this.productFilterService.SELECT[CATEGORY](this.productFilterService.sortByName(newSection.category)),
    ];
  }

  resetFilters() {
    const {GENDER, CATEGORY, AVAILABILITY, MARKET, STORE} = this.PRODUCT_CONSTANT.FILTER;
    const geoFilters = this.filterGeographyFilters();
    const newFilters = [...this.baseFilters, ...geoFilters];
    const forceValue = {
      genderId: this.productFilterService.DEFAULT_OPTIONS[GENDER].value,
      categoryId: this.productFilterService.DEFAULT_OPTIONS[CATEGORY].value,
      availability: this.productFilterService.DEFAULT_OPTIONS[AVAILABILITY].value,
      marketId: this.productFilterService.DEFAULT_OPTIONS[MARKET].value,
      storeId: this.productFilterService.DEFAULT_OPTIONS[STORE].value,
      regionId: this.activeFilters.region.value,
    };
    this.activeFilters = this.setActiveFilters(newFilters, forceValue);
    this.filters = geoFilters;
  }

  formatPlaceholders() {
    const {GENDER, CATEGORY, AVAILABILITY, STORE, REGION, MARKET} = this.PRODUCT_CONSTANT.FILTER;
    return Object.keys(this.productFilterService.SELECT).reduce((acc, key) => {
      if (key !== GENDER && key !== CATEGORY && key !== AVAILABILITY && key !== STORE && key !== REGION && key !== MARKET) {
        acc[key] = this.productFilterService.SELECT[key]();
      }
      return acc;
    }, {});

    // return this.isPersonalShopper
    //   ? this.productFilterService.removeFiltersForPersonalShopper(selectPlaceholders)
    //   : selectPlaceholders;
  }

  getFiltersLabels() {
    const {REGION, STORE, MARKET, AVAILABILITY} = this.PRODUCT_CONSTANT.FILTER;
    return [REGION, STORE, MARKET, AVAILABILITY];
  }

  filterProductFilters() {
    return this.filters.filter(f => !this.getFiltersLabels().includes(f.name));
  }

  filterGeographyFilters() {
    return this.filters.filter(f => this.getFiltersLabels().includes(f.name));
  }

  orderAvailabilityOptions(filters) {
    const {ALL_AVAILABILITIES, IN_MARKET, IN_STORE, AVAILABILITY} = this.PRODUCT_CONSTANT.FILTER;
    const defaultAvailabilityValue = this._getDefaultAvailabilityValue();
    const availabilitiesOrder = [ALL_AVAILABILITIES, defaultAvailabilityValue, IN_MARKET, IN_STORE];
    if (filters) {
      return filters.forEach((f) => {
        if (f.name === AVAILABILITY) {
          f.options.sort((a, b) => {
            return availabilitiesOrder.indexOf(a.value) - availabilitiesOrder.indexOf(b.value);
          });
        }
      });
    }
  }

  showSelect(filterName) {
    const {AVAILABILITY, SIZE} = this.PRODUCT_CONSTANT.FILTER;
    const categoryValue = this.activeFilters.category.value;
    const genderValue = this.activeFilters.gender.value;

    if (filterName === SIZE) {
      return !this.loadingFilters && Boolean(_get(this.productFilterService.getFilterConfig(), `${categoryValue}.${genderValue}.${SIZE}`));
    }

    return !(this.loadingFilters || !categoryValue) || filterName === AVAILABILITY;
  }
}



// WEBPACK FOOTER //
// ./src/app/product/product-filter/product-filter-form/product-filter-form.controller.js